var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.list,"border":""}},[_c('el-table-column',{attrs:{"label":"页面","prop":"name"}}),_c('el-table-column',{attrs:{"label":"链接","prop":"link"}}),_c('el-table-column',{attrs:{"label":"备注","prop":"note"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }